import {Stack, styled} from '@mui/material';

const ContentContainer = styled(Stack)`
	gap: 16px;
	padding: 16px 16px 0px;
	max-height: 100%;
	overflow: auto;
`;

const StyledStack = styled(Stack)`
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;

const ActionContainer = styled('div')`
	padding: 16px;
`;

export {ContentContainer, StyledStack, ActionContainer};
